
import React, { useEffect } from 'react';
import AnimatedNumber from '../components/AnimatedNumber';
import '../styles/Staffing.css';


const Staffing = () => {
	useEffect(() => {
		document.title = "Staffing | Inypeople";
	}, []);
	return (
		<>
			<div className="staffing-hero">
				<div className="staffing-hero-content">
					<div className="staffing-hero-left">
						<h1>
							Connecting <span className="highlight-purple">Talent</span> <br />
							with <span className="highlight-blue">Opportunity</span>
						</h1>
						<p>
							At Inypeople, we bridge the gap between ambitious companies and exceptional talent. Our Recruitment services are designed to match the right skills with the right roles. We deliver hiring solutions tailored to your business goals and growth needs.
						</p>
						<div className="staffing-hero-stats">
							<div className="staffing-hero-icons-group">
								<span className="user-icon">
									<img src="/assets/icons/user.png" alt="User Icon" width="40" height="40" />
								</span>
								<span className="user-icon">
									<img src="/assets/icons/user.png" alt="User Icon" width="40" height="40" />
								</span>
								<span className="user-icon">
									<img src="/assets/icons/user.png" alt="User Icon" width="40" height="40" />
								</span>
								<span className="user-icon">
									<img src="/assets/icons/user.png" alt="User Icon" width="40" height="40" />
								</span>
								<span className="user-badge">
									<img src="/assets/icons/100+-icon.png" alt="100+ Badge" width="40" height="40" />
								</span>
							</div>
							<div className="staffing-hero-stats-text">
								<strong><AnimatedNumber value={100} duration={1200} suffix="+" style={{ color: '#000000' }} /> Successful Hires</strong>
								<span>Trusted by top companies</span>
							</div>
						</div>
					</div>
					<div className="staffing-hero-right">
						<div className="staffing-hero-image-card">
							{/* Replace with your actual image path */}
							<img src="/assets/images/hero-image.jpg" alt="Handshake" />
							<div className="staffing-hero-card">
								<div>
									<span className="card-value"><AnimatedNumber value={98} duration={1200} suffix="%" /></span>
									<span className="card-label">Retention Rate</span>
								</div>
								<div>
									<span className="card-value2"><AnimatedNumber value={24} duration={1200} suffix="h" /></span>
									<span className="card-label">Turnaround Time</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* No bottom gradient */}
			</div>

			{/* Staffing Status Section (not a component) */}
			<section className="staffing-status-section">
				<div className="staffing-status-container">
					<div className="staffing-status-item">
						<div className="status-icon-bg">
							<img src="/assets/icons/people-status.png" alt="Successful Hires" width="24" height="24" />
						</div>
						<div className="status-value"><AnimatedNumber value={100} duration={1200} suffix="+" startOnView={true} /></div>
						<div className="status-label">Successful Hires</div>
					</div>
					<div className="staffing-status-item">
						<div className="status-icon-bg">
							<img src="/assets/icons/happy-clients.png" alt="Happy Clients" width="24" height="24" />
						</div>
						<div className="status-value"><AnimatedNumber value={50} duration={1200} suffix="+" startOnView={true} /></div>
						<div className="status-label">Happy Clients</div>
					</div>
					<div className="staffing-status-item">
						<div className="status-icon-bg">
							<img src="/assets/icons/industries.png" alt="Industries Served" width="24" height="24" />
						</div>
						<div className="status-value"><AnimatedNumber value={10} duration={1200} suffix="+" startOnView={true} /></div>
						<div className="status-label">Industries Served</div>
					</div>
					<div className="staffing-status-item">
						<div className="status-icon-bg">
							<img src="/assets/icons/trust.png" alt="Years of Building Trust" width="24" height="24" />
						</div>
						<div className="status-value"><AnimatedNumber value={2} duration={1200} suffix="+" startOnView={true} /></div>
						<div className="status-label">Years of Building Trust</div>
					</div>
				</div>
			</section>

			{/* Expertise Section */}
			<section className="expertise-section">
				<div className="expertise-header">
					<div className="expertise-title">OUR EXPERTISE</div>
					<div className="expertise-subtitle">Smart, Comprehensive Staffing Solutions</div>
					<div className="expertise-desc">We Deliver Tailored Staffing Strategies Designed To Meet The Unique Challenges Of Your Business.</div>
				</div>
				<div className="expertise-cards-container">
					<div className="expertise-card">
						<div className="expertise-card-icon-bg">
							<img src="/assets/icons/solar-cup-outline.png" alt="Permanent Staffing" width="24" height="24" />
						</div>
						<div className="expertise-card-title">Permanent Staffing</div>
						<div className="expertise-card-content">
							<ul>
								<li>Build Strong Teams With Full-Time Talent That Fits Your Business And Culture.</li>
								<li>Our Permanent Staffing Solutions Ensure The Right Match Every Time.</li>
								<li>We Deliver Professionals Who Add Value From Day One.</li>
							</ul>
						</div>
					</div>
					<div className="expertise-card">
						<div className="expertise-card-icon-bg">
							<img src="/assets/icons/ph-building.png" alt="Contract Staffing" width="24" height="24" />
						</div>
						<div className="expertise-card-title">Contract Staffing</div>
						<div className="expertise-card-content">
							<ul>
								<li>Access Skilled Professionals For Short-Term And Project-Based Requirements.</li>
								<li>Our Contract Staffing Solutions Offer Flexibility Without Compromising Quality.</li>
								<li>Scale Your Workforce Quickly To Meet Changing Business Demands.</li>
							</ul>
						</div>
					</div>
					<div className="expertise-card">
						<div className="expertise-card-icon-bg">
							<img src="/assets/icons/octicon-people-24.png" alt="Executive Search" width="24" height="24" />
						</div>
						<div className="expertise-card-title">Executive Search</div>
						<div className="expertise-card-content">
							<ul>
								<li>Identify And Attract Senior Leaders Who Drive Strategic Growth.</li>
								<li>Our Executive Search Process Focuses On Expertise, Leadership, And Cultural Fit.</li>
								<li>We Help You Secure Talent That Makes A Lasting Impact.</li>
							</ul>
						</div>
					</div>
					<div className="expertise-card">
						<div className="expertise-card-icon-bg">
							<img src="/assets/icons/octicon-people-25.png" alt="Bulk & Volume Hiring" width="24" height="24" />
						</div>
						<div className="expertise-card-title">Bulk & Volume Hiring</div>
						<div className="expertise-card-content">
							<ul>
								<li>Meet Large-Scale Hiring Needs With Speed And Precision.</li>
								<li>Our Bulk Hiring Solutions Streamline Sourcing, Screening, And Onboarding.</li>
								<li>Build High-Performing Teams Efficiently, Even At Scale.</li>
							</ul>
						</div>
					</div>
					<div className="expertise-card">
						<div className="expertise-card-icon-bg">
							<img src="/assets/icons/ri-user-star-line.png" alt="Industry-Specific Staffing" width="24" height="24" />
						</div>
						<div className="expertise-card-title">Industry-Specific Staffing</div>
						<div className="expertise-card-content">
							<ul>
								<li>Hire Talent With Deep Domain Knowledge And Relevant Experience.</li>
								<li>Our Industry-Focused Recruiters Understand Niche Skill Requirements.</li>
								<li>Ensuring Faster Hiring And Better Role Alignment.</li>
							</ul>
						</div>
					</div>
					<div className="expertise-card">
						<div className="expertise-card-icon-bg">
							<img src="/assets/icons/solar-cup-outline1.png" alt="Recruitment Process Outsourcing (RPO)" width="24" height="24" />
						</div>
						<div className="expertise-card-title">Recruitment Process Outsourcing (RPO)</div>
						<div className="expertise-card-content">
							<ul>
								<li>Optimize Your Hiring Operations With Our <br />End-To-End Recruitment Management.</li>
								<li>We Act As An Extension Of Your HR Team.</li>
								<li>Delivering Consistent, Scalable, And Cost-Effective Hiring Outcomes.</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
			{/* Hiring Process Section */}
			<section className="hiring-process-section">
				<div className="hiring-process-container">
					<div className="hiring-process-left">
						<div className="hiring-process-label">HOW WE WORK</div>
						<div className="hiring-process-heading">
							Simplified <br />
							<span>Hiring Process</span>
						</div>
						<div className="hiring-process-desc">
							We've Streamlined Our Recruitment Methodology To Deliver Speed Without Compromising On Quality.
						</div>
					</div>
					<div className="hiring-process-right">
						<div className="hiring-process-card">
							<div className="hiring-process-card-value">01</div>
							<div className="hiring-process-card-title">Requirement Analysis</div>
							<div className="hiring-process-card-desc">We Work Closely With You To Understand Your Specific Needs, Culture, And Technical Requirements.</div>
						</div>
						<div className="hiring-process-card">
							<div className="hiring-process-card-value">02</div>
							<div className="hiring-process-card-title">Smart Screening</div>
							<div className="hiring-process-card-desc">Our Team Sources Potential Candidates From Our Extensive Database And Conducts Thorough Initial Screenings.</div>
						</div>
						<div className="hiring-process-card">
							<div className="hiring-process-card-value">03</div>
							<div className="hiring-process-card-title">Interview & Assessment</div>
							<div className="hiring-process-card-desc">We Coordinate Interviews And Help Assess Candidates To Ensure They Are The Perfect Technical And Cultural Fit.</div>
						</div>
						<div className="hiring-process-card">
							<div className="hiring-process-card-value">04</div>
							<div className="hiring-process-card-title">Onboarding & Support</div>
							<div className="hiring-process-card-desc">We Assist With Salary Negotiation, Documentation, And Onboarding To Ensure A Smooth Transition.</div>
						</div>
					</div>
				</div>
			</section>
      {/* Industries Section (moved below hiring process) */}
			<section className="industries-section">
				<div className="industries-container">
					<div className="industries-left">
						<div className="industries-label">INDUSTRIES</div>
						<div className="industries-heading">Deep Domain Expertise</div>
						<div className="industries-images-grid">
							<div className="industries-image-wrapper industries-image-main">
								<img src="/assets/images/industry-it.jpg" alt="Information Technology" width="286" height="250" />
								<div className="industries-image-overlay"></div>
								<span className="industries-image-text">Information Technology</span>
								<span className="industries-image-subtext">Software, Infrastructure, AI & Data</span>
							</div>
							<div className="industries-image-col">
								<div className="industries-image-wrapper industries-image-upper">
									<img src="/assets/images/industry-healthcare.jpg" alt="Healthcare" width="260" height="230" />
									<div className="industries-image-overlay"></div>
									<span className="industries-image-text">Healthcare</span>
									<span className="industries-image-subtext">Hospitals, Pharma, Bio-tech</span>
								</div>
								<div className="industries-image-wrapper industries-image-lower">
									<img src="/assets/images/industry-bfsi.jpg" alt="BFSI" width="290" height="220" />
									<div className="industries-image-overlay"></div>
									<span className="industries-image-text">BFSI</span>
									<span className="industries-image-subtext">Banking, Insurance, Fintech</span>
								</div>
							</div>
						</div>
					</div>
					<div className="industries-right">
						<div className="industries-right-heading">Let's Talk</div>
						<div className="industries-right-desc">
							Let’s create something great together. Inypeople is trusted by 100+ clients worldwide—partner with us to leverage our expertise and grow your business.
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default Staffing;
